module.exports = __webpack_public_path__ + "static/img/home-doctinfo.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home-doctinfo.png
// module id = 534
// module chunks = 0